// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Spin } from "../components/admin-ui";
import { AdminShell } from "../layouts/AdminShell";
import { useAdminTransaction } from "../api/hooks";
import { IssueRefundForm } from "../components/IssueRefundForm";

export function IssueRefundScreen() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: txn, isLoading } = useAdminTransaction(id);
  const refundSource = new URLSearchParams(location.search).get("from");
  const activeNav = (location.state as { activeNav?: string } | null)?.activeNav
    ?? (refundSource === "orders" ? "/orders" : refundSource === "transactions" ? "/transactions" : "/transactions");

  if (isLoading) {
    return (
      <AdminShell>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
          <Spin size="large" />
        </div>
      </AdminShell>
    );
  }

  if (!txn) {
    return (
      <AdminShell>
        <div style={{ padding: 40, textAlign: "center", color: "#9CA3AF" }}>{t("issueRefund.notFound")}</div>
      </AdminShell>
    );
  }

  return (
    <AdminShell>
      <IssueRefundForm
        txn={txn}
        onBack={() => navigate(-1)}
        onOrderClick={(orderId) => {
          const source = activeNav === "/transactions" ? "transactions" : "orders";
          navigate(`/orders/${orderId}`, { state: { activeNav } });
        }}
        onSuccess={() => navigate(`/transactions/${id ?? ""}`, { state: { activeNav } })}
      />
    </AdminShell>
  );
}
